// src/data/googleReviews.ts
export const googleReviews = {
  rating: 5.0,
  total: 16,
  reviews: [
    {
      user: "Oscar de la Cruz",
      text: "Muy buen servicio y agilidad en la atención",
      date: "2 semanas atrás",
      stars: 5
    },
    {
      user: "Marcelo Roel",
      text: "Excelente atención son responsables puntuales y de confianza los recomiendo a todos.",
      date: "2 semanas atrás",
      stars: 5
    },
    {
      user: "Candela",
      text: "Excelente atención y servicio! Los mejores",
      date: "2 semanas atrás",
      stars: 5
    },
    {
      user: "Maxi Reinoso",
      text: "Excelente atención, súper recomendable 👌…",
      date: "2 semanas atrás",
      stars: 5
    },
    {
      user: "Germán Torres",
      text: "La atención es muy buena y excelente la atención!!!",
      date: "Hace un mes",
      stars: 5
    },
    {
      user: "Juan Navarro Bugueño",
      text: "Consulte para dejar mi auto y me atendieron muy bien!! Lo recomiendo 100% !",
      date: "2 semanas atrás",
      stars: 5
    },
    {
      user: "Agustina Eyherabide",
      text: "Excelente! La confianza que generan y cómo pudieron despejar todas mis dudas. Los recomiendo!",
      date: "una semana atrás",
      stars: 5
    },
    {
      user: "Marcos Augusto Rojas",
      text: "Muy buena empresa de alquiler de autos para trabajar en plataformas, los muchachos te atienden bárbaro, súper recomendable",
      date: "2 semanas atrás",
      stars: 5
    }
  ]
};
